import { Box, Paper, styled } from '@mui/material';

export const WorkerListCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: '12px',
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
  height: '100%',
}));

export const WorkerItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(2, 0),
  borderBottom: '1px solid #f0f0f0',
  '&:last-child': {
    borderBottom: 'none',
  },
}));

export const StatusBadge = styled(Box)<{ status: string }>(({ theme, status }) => {
  let backgroundColor = '#e0e0e0';
  let color = '#757575';

  if (status === 'active') { // On Time
    backgroundColor = '#e8f5e9'; // Green 50
    color = '#2e7d32'; // Green 800
  } else if (status === 'upcoming') { // Upcoming
    backgroundColor = '#e3f2fd'; // Blue 50
    color = '#1565c0'; // Blue 800
  } else if (status === 'pending' || status === 'noshow') { // No Show
    backgroundColor = '#ffebee'; // Red 50
    color = '#c62828'; // Red 800
  }

  return {
    backgroundColor,
    color,
    padding: '2px 8px',
    borderRadius: '4px',
    fontSize: '0.70rem',
    fontWeight: 500,
    textTransform: 'capitalize',
    marginLeft: theme.spacing(1),
    display: 'inline-block',
  };
});

export const ManageButton = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: theme.spacing(2),
}));
